import CheckoutOrderSummary from './CheckoutOrderSummary';

export default CheckoutOrderSummary;
